require('./bewaesserungUtils');
const $ = require('jquery');

/**
 * bewaesserung_sortWithParameter
 * @param sort
 * @param recordID
 * @param hasOpenSections
 * @param isAbgegeben
 */
window.bewaesserung_sortWithParameter = function(sort, recordID, hasOpenSections, isAbgegeben) {
  const checked = $('div[data-section-uid]').has('input:checked').map(function() {
    return parseInt($(this).data('section-uid'));
  }).get();

  const activeButtons = $('.active-buttons');
  if (activeButtons.length > 0) {
    activeButtons.removeClass('active');

    const firstLevelButton = $('#show-first-level');
    if (sort === 'betrieb') {
      firstLevelButton.text(LANG_STRINGS.anlagen);
    } else if (sort === 'sorte' || sort === 'pflanzjahr') {
      firstLevelButton.text(LANG_STRINGS.betriebe);
    }
  }

  const ListAufzeichnungFlaechenBewaesserung = new AjaxItem('aufzeichnungFlaechenBewaesserung', {}, {}, 'aufzeichnungen');
  ListAufzeichnungFlaechenBewaesserung.poster({
    checked: checked,
    sortby: sort,
    recordID: recordID,
    hasOpenSections: hasOpenSections,
    isAbgegeben: isAbgegeben,
  });
};

/**
 * spritzung_showHideLockedDataset
 * @param currentElement
 * @param recordID
 * @param hasOpenSections
 * @param isAbgegeben
 */
window.bewaesserung_showHideLockedDataset = function(currentElement, recordID, hasOpenSections, isAbgegeben) {
  const checked = $('div[data-section-uid]').has('input:checked').map(function() {
    return parseInt($(this).data('section-uid'));
  }).get();

  const ListAufzeichnungFlaechenBewaesserung = new AjaxItem('aufzeichnungFlaechenBewaesserung', {}, {}, 'aufzeichnungen');
  ListAufzeichnungFlaechenBewaesserung.poster({
    checked: checked,
    recordID: recordID,
    hasOpenSections: hasOpenSections,
    isAbgegeben: isAbgegeben,
    showHideLockedDataset: 1,
  });

  if ($(currentElement).find('span').hasClass('show-txt-0')) {
    $(currentElement).find('span').html(LANG_STRINGS.gesperrteAbschnitteAusblenden);
    $(currentElement).find('span').removeClass('show-txt-0').addClass('show-txt-1');
  } else {
    $(currentElement).find('span').html(LANG_STRINGS.gesperrteAbschnitteEinblenden);
    $(currentElement).find('span').removeClass('show-txt-1').addClass('show-txt-0');
  }
};

/**
 * bewaesserung_buildAbschnittData
 * @returns {{alleAbschnitteId: *[], summe: *, abschnitte: {}}}
 */
window.bewaesserung_buildAbschnittData = function() {
  let dataSectionID = $('[data-section-uid]');
  dataSectionID.hasNot('input:checked').map(function() {
    bewaesserung_resetAbschnittData($(this));
  });

  const abschnitte = {};
  let sumFlaeche = 0;
  dataSectionID.has('input:checked').map(function() {
    sumFlaeche += Number($(this).find('input[name="flaeche"]').val());
  });

  let dauer = 0;
  const inputDauer = $('#input-dauer');
  if (inputDauer.length > 0 && inputDauer.val() !== '') {
    dauer = parseFloat(inputDauer.val());
  }

  let typ = '';
  dataSectionID.has('input:checked').map(function() {
    const abschnittFlaeche = Number($(this).find('input[name="flaeche"]').val());
    const abschnittID = Number($(this).attr('data-section-uid'));

    typ = $(this).find('.bewaesserung-typ').val();

    abschnitte[abschnittID] = {
      id: abschnittID,
      flaeche: abschnittFlaeche,
      wassermengeBerechnetMillimeter: 0,
      wassermengeMillimeter: 0,
      dauer: dauer,
      typ: $(this).find('.bewaesserung-typ').val(),
      oberkrone: Number($(this).find('.bewaesserung-oberkrone').val()),
      tropfer: Number($(this).find('.bewaesserung-tropfer').val()),
      pflanzabstand: Number($(this).find('.bewaesserung-pflanzabstand').val()),
      anzahlPflanzen: Number($(this).find('.bewaesserung-anzahlPflanzen').val()),
      bewaesserungsanlage: {
        oberkrone_anzahl: Number($(this).find('.bewaesserung-oberkrone_anzahl').val()),
        oberkrone_druck_duese: Number($(this).find('.bewaesserung-oberkrone_druck_duese').val()),
        oberkrone_durchmesser_duese: Number($(this).find('.bewaesserung-oberkrone_durchmesser_duese').val()),
        flaeche: Number($(this).find('.bewaesserung-sumBewaesserungsanlage').val()),
        tropfer_abstand_tropfer: Number($(this).find('.bewaesserung-tropfer_abstand_tropfer').val()),
        tropfer_wassermenge_pro_tropfer: Number($(this).find('.bewaesserung-tropfer_wassermenge_pro_tropfer').val()),
      },
    };
  });

  // Abschnitt-IDs
  let alleAbschnitteID = [];
  $.each(abschnitte, function(k, v) {
    alleAbschnitteID.push(v.id);
  });

  const summe = {
    flaeche: sumFlaeche,
    typ: typ,
  };

  const summeNeu = bewaesserung_recalculateSumme(summe, dauer, alleAbschnitteID, abschnitte, true);

  return {
    abschnitte: abschnitte,
    alleAbschnitteId: alleAbschnitteID,
    summe: summeNeu,
  };
};

/**
 *
 * @param reload
 * @param recordID
 */
window.bewaesserung_checkBeregnungssystem = function(reload, recordID) {
  $('.beregnungssystem').on('change', function() {
    if (reload) {
      $.ajax({
        url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.changeBeregnungssystemBewaesserung',
        data: {
          recordID: recordID,
          beregnungssystem: $(this).val(),
        },
        type: 'post',
        success: function(data) {
          if (data.success) {
            window.location = BASE_PATH + 'aufzeichnungen/bewaesserung/' + recordID + '?step=2';
          }
        },
        dataType: 'json',
      });
    }
  });
};

/**
 * bewaesserung_bindIntervall
 */
window.bewaesserung_bindIntervall = function() {
  const build = bewaesserung_buildAbschnittData();

  const recommendedWassermenge = $('.recommended-wassermenge');
  if (recommendedWassermenge.length > 0) {
    recommendedWassermenge.val(build.summe.wassermengeBerechnetMillimeter);
  }

  // Mit Enter weiter
  $('input, select, textarea').not('.textarea_bemerkung, .input-wochentag, #bemerkung').keypress(function(event) {
    // 10 is for mac
    if (event.keyCode === 13 || event.keyCode === 10) {
      event.preventDefault();
      $(this).closest('div').not('.skip-enter').next().find('input,select,textarea').focus();
    }
  });

  // Focus auf Select Intervall setzen
  $('#intervall-row').find('select#select-intervall:not([readonly="readonly"])').focus();

  // LISTENER
  const selectIntervallType = $('select#select-intervall');
  let intervallType = parseInt(selectIntervallType.val());

  // Select Intervall
  selectIntervallType.on('change', function() {
    // alten Intervalltyp merken für parseIntervallType
    const intervallTypeOld = intervallType;
    intervallType = parseInt($(this).val());

    // prüfen, ob man die bereits eingegebenen Werte konvertieren kann
    const between = bewaesserung_parseIntervallType(intervallType, intervallTypeOld);

    // Reset
    $('#col-datum-vom, #col-datum-bis, #col-datum-auswahl, #col-uhrzeit, #col-wochentage, #col-tage-ohne-bewaesserung, #col-dauer, #col-wassermenge, #col-wassermenge-berechnet, #col-bewaessserungShow, #col-bemerkung').addClass('display-none');
    $('#input-zeitspanne-vom, #input-zeitspanne-bis, #input-uhrzeit, #input-tage-ohne-bewaesserung, #input-dauer, #input-wassermenge').attr('readonly', 'readonly');

    // wenn man nicht zwischen Intervalltyp 4 und 5 wechselt
    if (!((intervallTypeOld === 4 || intervallTypeOld === 5) && (intervallType === 4 || intervallType === 5))) {

    }

    if (intervallType === 1) {
      // Täglich
      $('#col-datum-vom, #col-datum-bis, #col-uhrzeit, #col-dauer, #col-wassermenge, #col-wassermenge-berechnet, #col-bewaessserungShow, #col-bemerkung').removeClass('display-none');
      $('#input-zeitspanne-vom, #input-zeitspanne-bis, #input-uhrzeit, #input-dauer, #input-wassermenge').removeAttr('readonly');

      if (between.length > 0) {
        $('#input-zeitspanne-vom').val(between[0]);
        $('#input-zeitspanne-bis').val(between[1]);
      }

      bewaesserung_initListeners(1);
    } else if (intervallType === 2) {
      // Wöchentlich
      $('#col-datum-vom, #col-datum-bis, #col-uhrzeit, #col-dauer, #col-wochentage, #col-wassermenge, #col-wassermenge-berechnet, #col-bewaessserungShow, #col-bemerkung').removeClass('display-none');
      $('#input-zeitspanne-vom, #input-zeitspanne-bis, #input-uhrzeit, #input-dauer, #input-wassermenge').removeAttr('readonly');

      $('#input-zeitspanne-vom').val(between[0]);
      $('#input-zeitspanne-bis').val(between[1]);

      if (between[2] !== undefined && between[2].length > 0) {
        $.each(between[2], function(key, value) {
          $('#col-wochentage').find('input[value="' + value + '"]').prop('checked', true);
        });
      }

      // 8 Tage Abstand
      bewaesserung_initListeners(8);
    } else if (intervallType === 3) {
      // Jeden bestimmten Tag
      $('#col-datum-vom, #col-datum-bis, #col-uhrzeit, #col-tage-ohne-bewaesserung, #col-dauer, #col-wassermenge, #col-wassermenge-berechnet, #col-bewaessserungShow, #col-bemerkung').removeClass('display-none');
      $('#input-zeitspanne-vom, #input-zeitspanne-bis, #input-uhrzeit, #input-dauer, #input-tage-ohne-bewaesserung, #input-dauer, #input-wassermenge').removeAttr('readonly');

      $('#input-tage-ohne-bewaesserung, #input-zeitspanne-vom, #input-zeitspanne-bis').val('');
      if (between.length > 0) {
        $('#input-zeitspanne-vom').val(between[0]);
        $('#input-zeitspanne-bis').val(between[1]);
        $('#input-tage-ohne-bewaesserung').val(between[2]);
      }

      bewaesserung_initListeners(0);
    } else if (intervallType === 4 || intervallType === 5) {
      // Einmalig oder mehrere Tage
      $('#col-datum-auswahl, #col-uhrzeit, #col-dauer, #col-wassermenge, #col-wassermenge-berechnet, #col-bewaessserungShow, #col-bemerkung').removeClass('display-none');
      $('#input-uhrzeit, #input-dauer, #input-wassermenge').removeAttr('readonly');

      let dateOutput = '';
      let dateOutputGui = '';
      if (between !== undefined && between.length > 0) {
        for (let i = 0; i < between.length; i++) {
          dateOutput += between[i];

          const date = new Date(between[i]);
          dateOutputGui += formatDate(date);
          if (i < between.length - 1) {
            dateOutput += ',';
            dateOutputGui += ', ';
          }
        }
      }

      $('#input-zeitspanne-auswahl').val(dateOutput);
      $('#input-zeitspanne-auswahl-gui').val(dateOutputGui);
    }
  });

  $('#input-tage-ohne-bewaesserung').on('change input', function() {
    bewaesserung_initListeners(parseInt($(this).val()) + 1);
  });

  $('input#input-dauer').on('keyup change paste', function() {
    bewaesserung_calc(bewaesserung_buildAbschnittData(), {
      type: 'SUMME_BEWAESSERUNGEN_DAUER_CHANGING',
      dauer: $(this).val(),
    });
  });

  $('input#input-wassermenge').on('keyup change paste', function() {
    bewaesserung_calc(bewaesserung_buildAbschnittData(), {
      type: 'WASSERMENGE_MM_CHANGING',
      mm: $(this).val(),
    });
  });

  // Empfehlung übernehmen
  $('.empfehlung-sbr-assume').on('click', function() {
    const recommendedWassermenge = $('.recommended-wassermenge');
    if (Number(recommendedWassermenge.val()) > 0) {
      $('#input-wassermenge').val(recommendedWassermenge.val()).trigger('change');
      document.getElementById('message-wassermenge').classList.add('display-none');
    }
  });
};

/**
 * berechnet falls möglich die Daten für den Wechsel der Intervalltypen neu
 * Achtung: manchmal ändern sich Zeiträume.
 * z.B. wöchentlich 8.6.-21.6. am Montag => einmalig oder mehrere/Frostberegnung: 8.6., 15.6. => zurück zu wöchentlich wird Zeitraum 8.6.-15.6. am Montag
 * @param intervallType
 * @param intervallTypeOld
 */
window.bewaesserung_parseIntervallType = function(intervallType, intervallTypeOld) {
  const inputZeitspanneVom = $('#input-zeitspanne-vom');
  const start = new Date(inputZeitspanneVom.val() + ' 12:00:00'); // wegen Zeitumstellungproblem 12:00:00
  const end = new Date($('#input-zeitspanne-bis').val() + ' 12:00:00'); // wegen Zeitumstellungproblem 12:00:00
  const zeitspanneAuswahl = $('#input-zeitspanne-auswahl');
  let between = [];
  let currentDate;

  if (intervallType === 4 || intervallType === 5) {
    // Wechsel auf einmalig oder mehrere/Frostberegnung
    if (intervallTypeOld === 1) {
      // von täglich zu einmalig oder mehrere/Frostberegnung

      // korrekte Eingabe? (start+Enddatum vorhanden)
      if (start != null && end != null) {
        currentDate = new Date(start.getTime());
        while (currentDate <= end) {
          between.push(currentDate.toISOString().substring(0, 10));
          currentDate.setDate(currentDate.getDate() + 1);
        }
      }

      return between;
    } else if (intervallTypeOld === 2) {
      // von wöchentlich zu einmalig oder mehrere/Frostberegnung

      // Wochentage, an denen bewässert wird
      const wochentage = [];
      const colWochentag = $('#col-wochentage');
      if (colWochentag.find('input[type="checkbox"]:checked').length > 0) {
        colWochentag.find('input[type="checkbox"]:checked').each(function() {
          wochentage.push(parseInt($(this).val()));
        });
      }

      if (start != null && end != null && wochentage.length > 0) {
        function getDaysArray(start, end) {
          const array = [];
          for (const datetime = new Date(start); datetime <= end; datetime.setDate(datetime.getDate() + 1)) {
            array.push(new Date(datetime));
          }
          return array;
        }

        const dayList = getDaysArray(new Date(start.getTime()), new Date(end.getTime()));
        dayList.map((v) => v.toISOString().slice(0, 10)).join('');

        if (dayList.length > 0) {
          $.each(dayList, function(dayKey, dayValue) {
            let dateID = dayValue.getDay();
            if (dateID === 0) {
              dateID = 7;
            }

            $.each(wochentage, function(key, value) {
              if (parseInt(dateID) === parseInt(value)) {
                between.push(dayValue);
              }
            });
          });
        }
      }

      between = between.map((v) => v.toISOString().substring(0, 10));

      return between;
    } else if (intervallTypeOld === 3) {
      // von Jeden bestimmten Tag zu einmalig oder mehrere/Frostberegnung

      // Tage, an denen nicht bewässert wird
      const tageOhneBewaesserung = parseInt($('#input-tage-ohne-bewaesserung').val());

      // korrekte Eingabe? (start+Enddatum vorhanden+tage ohne Bewässerung)
      if (start != null && end != null && tageOhneBewaesserung != null) {
        currentDate = new Date(start.getTime());
        while (currentDate <= end) {
          between.push(currentDate.toISOString().substring(0, 10));
          currentDate.setDate(currentDate.getDate() + tageOhneBewaesserung + 1);
        }
      }

      return between;
    } else if (intervallTypeOld === 4 || intervallTypeOld === 5) {
      return zeitspanneAuswahl.split(',');
    }
  } else if (intervallTypeOld === 4 || intervallTypeOld === 5) {
    // von einmalig oder mehrere/Frostberegnung zu irgendwas
    const selectedDates = zeitspanneAuswahl.val().split(',');

    if (intervallType === 1) {
      // von einmalig oder mehrere/Frostberegnung zu täglich
      return [selectedDates[0], selectedDates[selectedDates.length - 1]];
    } else if (intervallType === 2) {
      // von einmalig oder mehrere/Frostberegnung zu wöchentlich
      let date;
      const wochentage = [];

      if (selectedDates !== undefined && selectedDates.length > 0) {
        for (let i = 0; i < selectedDates.length; i++) {
          if (selectedDates[i] !== '') {
            date = parseDate(selectedDates[i]); // 9.6
            if ($.inArray((date.getDay() + 6) % 7, wochentage) === -1) {
              wochentage.push((date.getDay() + 6) % 7);
            }

            const tmp = date.toISOString().substring(0, 10);

            // wenn das Datum der nächsten wöchentlichen Wiederholung kleiner ist als das höchste Datum, muss es im Array der ausgewählten Daten vorhanden sein
            if (tmp <= parseDate(selectedDates[selectedDates.length - 1])) {
              // Datum nicht vorhanden -> keine wöchentliche Wiederholung möglich
              if ($.inArray(formatDate(tmp), selectedDates) === -1) {
                return [];
              }
            }
          }
        }
      }

      return [selectedDates[0], selectedDates[selectedDates.length - 1], wochentage];
    } else if (intervallType === 3) {
      // von einmalig oder mehrere/Frostberegnung zu jedem bestimmten Tag
      let abstand = 0;

      // nur wenn es mehr wie einen Eintrag gibt kann konvertiert werden
      if (selectedDates.length > 1) {
        // -2 weil countDays Start und Enddatum mitzählt, wir aber nur die dazwischen wissen wollen
        const tmpDay1 = new Date(selectedDates[0]);
        const tmpDay2 = new Date(selectedDates[1]);

        abstand = countDays(tmpDay1, tmpDay2) - 1;

        // wenn der Abstand 0 ist, ist kein Konvertieren möglich, da 0 keine gültige Eingabe für tage_ohne_bewaesserung ist
        if (abstand === 0) {
          return [];
        }
        for (let i = 1; i < selectedDates.length - 1; i++) {
          // -2 weil countDays Start und Enddatum mitzählt, wir aber nur die dazwischen wissen wollen
          const tmpDay1 = new Date(selectedDates[i]);
          const tmpDay2 = new Date(selectedDates[i + 1]);

          const tmpAbstand = countDays(tmpDay1, tmpDay2) - 1;

          // wenn sich Abstand unterscheidet ist kein konvertieren möglich
          if (tmpAbstand !== abstand) {
            return [];
          }
        }
      } else {
        return [];
      }

      return [selectedDates[0], selectedDates[selectedDates.length - 1], abstand];
    }
  } else {
    return between;
  }
};

/**
 * bewaesserung_calc
 * @param state
 * @param action
 * @returns {(*&{summe: *, abschnitte: *})|*|(*&{summe: (*&{wassermengeMillimeter: (number|*)}), abschnitte: *})}
 */
window.bewaesserung_calc = function(state, action) {
  switch (action.type) {
    case 'SUMME_BEWAESSERUNGEN_DAUER_CHANGING': {
      const dauer = roundDauerAbschnittGui(Number(action.dauer));
      const abschnitteNeu = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => {
        const wassermengeMillimeter = roundWassermengeMillimeter(bewaesserung_berechneWassermenge(a, dauer, state.summe.typ).mm);
        return {
          ...a,
          wassermengeBerechnetMillimeter: wassermengeMillimeter,
          wassermengeBerechnetLiter: wassermengeMillimeter * a.flaeche,
        };
      }).reduce((alle, abschnitt) => ({...alle, [abschnitt.id]: abschnitt}), {});

      const summeNeu = bewaesserung_recalculateSumme(state.summe, dauer, state.alleAbschnitteId, abschnitteNeu);

      const calc = {
        ...state,
        abschnitte: abschnitteNeu,
        summe: summeNeu,
      };

      const recommendedWassermenge = $('.recommended-wassermenge');
      if (recommendedWassermenge.length > 0) {
        recommendedWassermenge.val(roundBruehe(calc.summe.wassermengeBerechnetMillimeter));
      }

      return calc;
    }

    case 'WASSERMENGE_MM_CHANGING': {
      const mmEingabe = roundWassermengeMillimeterGui(Number(action.mm));
      const flaecheGesamt = summiereFlaeche(state.alleAbschnitteId.map(id => state.abschnitte[id]));

      // wird verwendet, um das Verhaeltnis von berechneter Wassermenge eines Abschnitts zur berechneten Wassermenge gesamt zu berechnen.
      // Die Dauer kann man dabei kuerzen, deshalb kann eine beliebige Konstante verwendet werden.
      const dauer = 1000;
      const mmGesamtBerechnet = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => bewaesserung_berechneWassermenge(a, dauer, state.summe.typ)).map(m => m.liter).reduce((summe, l) => summe + l, 0) / flaecheGesamt;

      let literGesamt = 0;

      const abschnitteNeu = state.alleAbschnitteId.map(idAbschnitt => state.abschnitte[idAbschnitt]).map(a => {
        const mmBerechnet = bewaesserung_berechneWassermenge(a, dauer, state.summe.typ).mm;
        const wassermengeMillimeter = roundWassermengeMillimeter(mmEingabe * mmBerechnet / mmGesamtBerechnet);
        const wassermengeLiter = wassermengeMillimeter * a.flaeche;
        literGesamt += wassermengeLiter;
        return {
          ...a,
          wassermengeMillimeter: (!Number.isNaN(wassermengeMillimeter) ? wassermengeMillimeter : 0),
          wassermengeLiter: (!Number.isNaN(wassermengeLiter) ? wassermengeLiter : 0),
        };
      }).reduce((alle, abschnitt) => ({...alle, [abschnitt.id]: abschnitt}), {});

      const summeNeu = {
        ...state.summe,
        wassermengeMillimeter: roundWassermengeMillimeter(literGesamt / flaecheGesamt),
      };

      const calc = {
        ...state,
        abschnitte: abschnitteNeu,
        summe: summeNeu,
      };

      const recommendedWassermenge = $('.recommended-wassermenge');
      const oldValue = recommendedWassermenge.val();
      if (recommendedWassermenge.length > 0) {
        recommendedWassermenge.val(roundBruehe(calc.summe.wassermengeBerechnetMillimeter));
      }
      if (oldValue !== recommendedWassermenge.val()) {
        document.getElementById('message-wassermenge').classList.remove('display-none');
      }

      // Map Brühe auf alle Abschnitte
      const wassermengeManual = Number($('#wassermenge-manual').val());
      calc.alleAbschnitteId.map(idAbschnitt => calc.abschnitte[idAbschnitt]).map(a => {
        const wassermengeMilimeter = (!wassermengeManual ? a.wassermengeMillimeter : mmEingabe);
        const wassermengeLiter = (!wassermengeManual ? a.wassermengeLiter : mmEingabe * a.flaeche);

        const section = $('div[data-section-uid="' + a.id + '"]');
        section.find('.list-wassermengeMmGui').html(numberFormat(wassermengeMilimeter, DECIMAL_PLACES_DAUER_SUMME_GUI, ',', '.'));
        section.find('.list-wassermengeMm').val(roundWassermengeMillimeter(Number(wassermengeMilimeter)));

        section.find('.list-wassermengeLiterGui').html(numberFormat(wassermengeLiter, DECIMAL_PLACES_DAUER_SUMME_GUI, ',', '.'));
        section.find('.list-wassermengeLiter').val(roundWassermengeMillimeter(Number(wassermengeLiter)));
      });

      return calc;
    }

    case 'SUMME_BEWAESSERUNGEN_RESET_WASSERMENGE': {
      if (!state.summe.dauer) {
        return state;
      }
      const dauer = state.summe.dauer;
      const flaecheGesamt = summiereFlaeche(state.abschnitte);
      let literGesamt = 0;

      const abschnitteNeu = mapReduceAbschnitte(state.abschnitte, a => {
        const wassermengeMillimeter = roundWassermengeMillimeter(bewaesserung_berechneWassermenge(a, dauer, state.summe.typ).mm);
        const wassermengeLiter = wassermengeMillimeter * a.flaeche;
        literGesamt += wassermengeLiter;

        return {
          ...a,
          wassermengeMillimeter: wassermengeMillimeter,
        };
      });

      const summeNeu = {
        ...state.summe,
        wassermengeMillimeter: roundWassermengeMillimeter(literGesamt / flaecheGesamt),
      };

      return {
        ...state,
        abschnitte: abschnitteNeu,
        summe: summeNeu,
      };
    }

    case 'RESET_BEWAESSERUNG': {
      bewaesserung_calc(bewaesserung_buildAbschnittData(), {
        type: 'WASSERMENGE_MM_CHANGING',
        mm: $('input#input-wassermenge').val(),
      });

      return true;
    }
  }
};

/**
 * bewaesserung_initListeners
 * @param offset
 */
window.bewaesserung_initListeners = function(offset) {
  const inputZeitspanneVom = $('#input-zeitspanne-vom');
  inputZeitspanneVom.removeAttr('min').removeAttr('max');

  const inputZeitspanneBis = $('#input-zeitspanne-bis');
  inputZeitspanneBis.removeAttr('min').removeAttr('max');

  if (inputZeitspanneVom.attr('data-factory-min')) {
    inputZeitspanneVom.attr('min', inputZeitspanneVom.attr('data-factory-min'));
  }
  if (inputZeitspanneBis.attr('data-factory-min')) {
    inputZeitspanneBis.attr('min', inputZeitspanneBis.attr('data-factory-min'));
  }

  inputZeitspanneVom.off('change init').on('change init', function() {
    if (inputZeitspanneVom.val()) {
      const minDate = new Date(inputZeitspanneVom.val());
      minDate.setDate(minDate.getDate() + offset);
      inputZeitspanneBis.attr('min', minDate.toISOString().substring(0, 10));
    } else {
      if (inputZeitspanneBis.attr('data-factory-min')) {
        inputZeitspanneBis.attr('min', inputZeitspanneBis.attr('data-factory-min'));
      } else {
        inputZeitspanneBis.removeAttr('min');
      }
    }
  });

  inputZeitspanneBis.off('change init').on('change init', function() {
    if (inputZeitspanneBis.val()) {
      const maxDate = new Date(inputZeitspanneBis.val());
      maxDate.setDate(maxDate.getDate() - offset);

      inputZeitspanneVom.attr('max', maxDate.toISOString().substring(0, 10));
    } else {
      if (inputZeitspanneVom.attr('data-factory-min')) {
        inputZeitspanneVom.attr('min', inputZeitspanneVom.attr('data-factory-min'));
      } else {
        inputZeitspanneVom.removeAttr('max');
      }
    }
  });
};

/**
 * bewaesserung_removeLastStep
 */
window.bewaesserung_removeLastStep = function() {
  const formID = '#bewaesserung';

  $('.accordion__kontrollen .accordion__item__body').remove();
  $('.accordion__kontrollen .accordion__item__title').addClass('form-submit').attr('onclick', 'insertAutoLoader(); $(\'' + formID + '\').trigger(\'submit\'); return false;');

  const buttonTriggerSubmit = $('button#trigger-submit');
  buttonTriggerSubmit.find('span').html(LANG_STRINGS.weiter);
  buttonTriggerSubmit.attr('onclick', 'insertAutoLoader(); $(\'' + formID + '\').trigger(\'submit\'); return false;');

  bewaesserung_bindSetAdditionalText();
};

/**
 * bewaesserung_bindRemoveLastStep
 */
window.bewaesserung_bindRemoveLastStep = function() {
  $('form#bewaesserung').find('input, select, textarea').change(function() {
    bewaesserung_removeLastStep();
  });
};

/**
 * bewaesserung_goToError
 * @param element
 */
window.bewaesserung_goToError = function(element) {
  const sectionID = $(element).attr('data-section-id');
  if (sectionID) {
    const foundRow = $('#list_aufzeichnungFlaechenBewaesserung').find('div.tree-item[data-section-uid=' + sectionID + ']');
    if (!foundRow.closest('div.accordion__item').hasClass('accordion__item--active')) {
      foundRow.closest('div.accordion__item').find('div.accordion__item__title').trigger('click');
    }

    if (!foundRow.hasClass('tree-item--active')) {
      foundRow.find('div.tree-item__heading__trigger').trigger('click');
    }

    $('html, body').animate({
      scrollTop: parseInt(foundRow.find('div.tree-item__heading__trigger').offset().top) - 40,
    }, 100);
  }
};

/**
 * bewaesserung_bindChangingFields
 * @param recordID
 */
window.bewaesserung_bindChangingFields = function(recordID) {
  // Change Culture
  $('.culture-checkbox').on('click', function() {
    const action = $(this).is(':checked') ? 'check' : 'uncheck';
    const kulturID = $(this).val();

    if (action === 'uncheck') {
      ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.editEingabeCultureChange?type=bewaesserung&kulturID=' + kulturID + '&recordID=' + recordID);
    } else {
      $.ajax({
        url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.setEingabeCulture',
        data: {
          type: 'bewaesserung',
          recordID: recordID,
          kulturID: kulturID,
          action: action,
        },
        dataType: 'json',
        type: 'post',
        success: function() {
          window.location.reload();
        },
      });
    }
  });
};

/**
 * bewaesserung_setAccordionField
 * @param type
 * @returns {string|*}
 */
window.bewaesserung_setAccordionField = function(type) {
  if (type === 'recordType') {
    const inputChecked = $('.record-type').find('input[type="radio"]:checked');
    return inputChecked.closest('label').find('.label').text();
  }

  if (type === 'beregnungssystem') {
    // .record-beregnungsystem radio boxen
    return $('.record-beregnungsystem').find('input[type="radio"]:checked').closest('label').find('.label').text();

  }

  if (type === 'kulturen') {
    const kulturNames = [];
    $('#kultur-list').find('input[type="checkbox"]:checked').each(function() {
      kulturNames.push($(this).closest('label').data('string'));
    });

    return kulturNames.join(', ');
  }

  if (type === 'datum') {
    return $('#record-year').val();
  }

  if (type === 'flaeche') {
    const abschnittData = bewaesserung_buildAbschnittData();
    return numberFormat(abschnittData.summe.flaeche / 10000, DECIMAL_PLACES_FLAECHE_HA_GUI, ',', '.') + ' ha';
  }

  if (type === 'mittel') {
    return $('#select-intervall option:selected').text();
  }
};

/**
 * bewaesserung_bindSetAdditionalText
 */
window.bewaesserung_bindSetAdditionalText = function() {
  const bewaesserungLayout = $('#bewaesserung');
  bewaesserungLayout.find('div.accordion__item__title__additional').each(function() {
    // Set RecordType
    if ($(this).find('.sub-record-type').length > 0) {
      $(this).find('.sub-record-type').html(bewaesserung_setAccordionField('recordType'));
    }

    // Set Beregnungssystem
    if ($(this).find('.sub-beregnungssystem').length > 0) {
      $(this).find('.sub-beregnungssystem').html(bewaesserung_setAccordionField('beregnungssystem'));
    }

    // Set Kulturen
    if ($(this).find('.sub-kulturen').length > 0) {
      $(this).find('.sub-kulturen').html(bewaesserung_setAccordionField('kulturen'));
    }

    // Set Datum
    if ($(this).find('.sub-jahr').length > 0) {
      $(this).find('.sub-jahr').html(bewaesserung_setAccordionField('datum'));
    }

    // Set Fläeche
    if ($(this).find('.sub-flaeche').length > 0) {
      $(this).find('.sub-flaeche').html(bewaesserung_setAccordionField('flaeche'));
    }

    // Set Mittel
    if ($(this).find('.sub-mittel').length > 0) {
      $(this).find('.sub-mittel').html(bewaesserung_setAccordionField('mittel'));
    }
  });

  bewaesserungLayout.find('div.accordion__item__title__additional').removeClass('display-none');
};

/**
 * bewaesserung_openSelectDateDialog
 */
window.bewaesserung_openSelectDateDialog = function() {
  ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.selectBewaesserungDates', 400, {
    post_data: {
      data: $('#input-zeitspanne-auswahl').val(),
    },
  });
};

window.bewaesserung_recalc = function() {
  const abschnittData = bewaesserung_buildAbschnittData();
  if ($.isEmptyObject(abschnittData.abschnitte) === false) {
    // Abschnittsdaten
    $.each(abschnittData.abschnitte, function(key, value) {
      const mittelAbschnittRow = $('.table-mittel-abschnitt').find('*[data-section-uid="' + value.id + '"]');
      if (mittelAbschnittRow.length > 0) {

      } else {
        // Abschnittsmittel neu erstellens
        const detailTable = $('.tree-item[data-section-uid="' + value.id + '"]').find('div.table-mittel-abschnitt');

        // Template
        let template = $('#mittel-abschnitt-row').html();

        // Replace
        template = template.replace(new RegExp('__SECTION_ID__', 'g'), value.id);
        template = template.replace(new RegExp('__WASSERMENGE_MM__', 'g'), '');
        template = template.replace(new RegExp('__WASSERMENGE_MM_GUI__', 'g'), '');
        template = template.replace(new RegExp('__WASSERMENGE_MM_CLASS__', 'g'), '');
        template = template.replace(new RegExp('__WASSERMENGE_LITER__', 'g'), '');
        template = template.replace(new RegExp('__WASSERMENGE_LITER_GUI__', 'g'), '');
        template = template.replace(new RegExp('__WASSERMENGE_LITER_CLASS__', 'g'), '');

        // Create new line or replace
        const mittelAbschnittRow = detailTable.find('div[data-section-uid="' + value.id + '"]');

        if (mittelAbschnittRow.length > 0) {
          mittelAbschnittRow.replaceWith(template);
        } else {
          detailTable.append(template);
        }
      }
    });
  }
};

// Document-Ready
$(function() {
  if (MODULE_FILE === 'bewaesserung') {
    // Bind bewaesserung_bindRemoveLastStep
    bewaesserung_bindRemoveLastStep();
  }
});